import React, { useState, useRef, useContext } from "react";
import PropTypes from "prop-types";
import styled, { ThemeContext } from "styled-components";
import CommentsContent from "../elements/CommentsContent";
import { MenuButton, MenuIcon, ContextMenu } from "../elements/ContextMenu";
import { StatusText, getEligibilityStatusStyles } from "../elements/CommonStyledComponents";

const EligibleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const FlyoutWrapper = styled.span`
  margin-top: 4px;
`;

const EligibilityPopover = styled(ContextMenu)`
  padding: 8px 0px;
  background-color: ${props => props.theme.white};
`;

const EligibleFormatter = ({ value, row }) => {
  // hooks && variable(s)
  const theme = useContext(ThemeContext);
  const targetRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { eligibilityComment } = row;
  const { bgColor, color } = getEligibilityStatusStyles(value, theme);

  // function(s)
  const toggleMenu = value => setIsOpen(value !== undefined ? value : !isOpen);

  return (
    <EligibleWrapper>
      {value && (
        <StatusText bgColor={bgColor} color={color}>
          {value === "Submitted" ? "Pending" : value === "Yes" ? "Approved" : value === "No" ? "Denied" : ""}
        </StatusText>
      )}
      {value === "No" ? (
        <FlyoutWrapper>
          <MenuButton ref={targetRef} onClick={() => setIsOpen(!isOpen)}>
            <MenuIcon iconName="fa-comment" />
          </MenuButton>
          <EligibilityPopover targetRef={targetRef} isOpen={isOpen} toggleMenu={toggleMenu}>
            <CommentsContent
              title="Denial Reason"
              content={eligibilityComment ? eligibilityComment : row.eligibilityComment ? row.eligibilityComment : ""}
            />
          </EligibilityPopover>
        </FlyoutWrapper>
      ) : null}
    </EligibleWrapper>
  );
};

EligibleFormatter.propTypes = {
  row: PropTypes.object,
  value: PropTypes.string
};

export default EligibleFormatter;
